import { COLORS } from '@shared/config/colors/colors';
import { FormGroup } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const StyledFormGroup = styled(FormGroup)<{ $error?: string }>`
    .rf-form-group__message {
        ${({ $error }) => !$error && 'margin-top: 0;'}
    }
`;

export const FilesList = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 8px;
`;

export const RadioWrapper = styled('div')`
    display: flex;
`;

export const InputBody = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 16px;
`;

export const FindInputWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const FindInputPlaceholder = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 12px;
    padding: 24px;
    background-color: ${COLORS.neutral_00};
    border: 1px solid ${COLORS.neutral_20};
`;
